// extracted by LIB_CSS_EXTRACT_LOADER
import "./fireworks-background_module.css"
export default {"root":"root-wlxOx3","canvas":"canvas-dP7eq7"};